import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, addDoc, deleteDoc, setDoc, query, orderBy } from "firebase/firestore";
import { getStorage, ref, deleteObject, uploadBytes, getDownloadURL } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

const storage = getStorage()
const storageImages = ref(storage, "achievementsIcons/");

Vue.use(VueAxios, Axios);

export default {
    state:{
        achievementsList:[],
        loadingStatusAchievementIcon:0,
        typesAchievementsList:[],
        categoriesAchievementsList:[],
        intervalsAchievementsList:[]
    },
    mutations:{
        SET_ACHIEVEMENTS_LIST(state, achievementsList) {
            state.achievementsList = achievementsList
        },
        SET_VALUE_LOADING_STATUS_ACHIEVEMENT_IMAGE(state, progress) {
            state.loadingStatusAchievementIcon = progress
        },
        SET_TYPES_ACHIEVEMENTS_LIST(state, typesAchievementsList){
            state.typesAchievementsList = typesAchievementsList
        },
        SET_CATEGORIES_ACHIEVEMENTS_LIST(state, categoriesAchievementsList){
            state.categoriesAchievementsList = categoriesAchievementsList
        },
        SET_INTERVALS_ACHIEVEMENTS_LIST(state, intervalsAchievementsList){
            state.intervalsAchievementsList = intervalsAchievementsList
        },
    },
    actions: {
        GetAchievementsList({ commit }) {
            return new Promise((resolve, reject) => {
                getDocs(collection(db, "achievementsList")).then((querySnapshot) => {
                        var achievementsList = [];
                        querySnapshot.forEach((doc) => {
                            let achievement = doc.data();
                            achievement.id = doc.id;
                            achievementsList.push(achievement);
                        });
                        commit("SET_ACHIEVEMENTS_LIST", achievementsList);
                        resolve(achievementsList);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        GetAchievement({ }, achievement){
            return new Promise(async (resolve, reject) => {
                try {
                    let resAchievement = await getDoc(doc(db, "achievementsList", achievement.id))
                    let gettedAchievement = resAchievement.data()

                    if(gettedAchievement.goalsReferences && gettedAchievement.goalsReferences.type !== ""){
                        let type = await getDoc(gettedAchievement.goalsReferences.type)
                        gettedAchievement.type = type.data()
                    }
                    if(gettedAchievement.goalsReferences && gettedAchievement.goalsReferences.category !== ""){
                        let category = await getDoc(gettedAchievement.goalsReferences.category)
                        gettedAchievement.category = category.data()
                    }
                    if(gettedAchievement.goalsReferences && gettedAchievement.goalsReferences.interval !== ""){
                        let interval = await getDoc(gettedAchievement.goalsReferences.interval)
                        gettedAchievement.interval = interval.data()
                    }
                    if(gettedAchievement.goalsReferences && gettedAchievement.goalsReferences.specificWorkout &&  gettedAchievement.goalsReferences.specificWorkout.isReferenced){
                        let specificWorkout = await getDoc(gettedAchievement.goalsReferences.specificWorkout.ref)
                        gettedAchievement.goalsReferences.specificWorkout.ref = specificWorkout.data()
                    }

                    resolve(gettedAchievement)
                } catch(error) {
                    reject(error)
                }
            })
        },
        DeleteAchievement({}, achievement) {
            return new Promise(async(resolve, reject) => {
                let storageRefImage = ref(storage, `achievementsIcons/${achievement.icon.ref}`);
                await deleteObject(storageRefImage)
                    .then(async() => {
                        await deleteDoc(doc(db, "achievementsList", achievement.id))
                            .then((res) => {
                                resolve(achievement.id);
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    }).catch((errorImg) => {
                        console.log('errorImg deleting storage', errorImg);
                        // Uh-oh, an error occurred!
                    });
                   
            });
        },
        UploadImageAchievement({ commit }, achievement) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storage, `achievementsIcons/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the bytes
                    await uploadBytes(storageRef, achievement.icon.img, { contentType: 'image/jpeg' });
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreateAchievement({}, achievement) {
            return new Promise(async(resolve, reject) => {
                delete achievement.icon.img
                achievement.createdAt = new Date()
                achievement.updatedAt = new Date()
                
                if(achievement.goalsReferences.type !== ""){
                    achievement.goalsReferences.type = doc(db, "typesAchievementsList", achievement.goalsReferences.type.id);
                }
                if(achievement.goalsReferences.category !== ""){
                    achievement.goalsReferences.category = doc(db, "categoriesAchievementsList", achievement.goalsReferences.category.id);
                }
                if(achievement.goalsReferences.interval !== ""){
                    achievement.goalsReferences.interval = doc(db, "intervalsAchievementsList", achievement.goalsReferences.interval.id);
                }
                if(achievement.goalsReferences && achievement.goalsReferences.specificWorkout && achievement.goalsReferences.specificWorkout.isReferenced){
                    achievement.goalsReferences.specificWorkout.ref = doc(db, achievement.goalsReferences.specificWorkout.collection, achievement.goalsReferences.specificWorkout.ref.id);
                }

                const newDocRef = doc(collection(db, "achievementsList"));
                achievement.id = newDocRef.id;
                await setDoc(newDocRef, achievement);
                resolve(newDocRef.id);
            })
        },
        UpdateAchievement({}, achievement) {
            return new Promise(async(resolve, reject) => {
                if(achievement.createdAt) {
                    delete achievement.createdAt
                }
                achievement.updatedAt = new Date()
                if (achievement.icon.img) {
                    delete achievement.icon.img
                }
                if(achievement.goalsReferences && achievement.goalsReferences.type !== ""){
                    achievement.goalsReferences.type = doc(db, "typesAchievementsList", achievement.goalsReferences.type.id);
                }
                if(achievement.goalsReferences && achievement.goalsReferences.category !== ""){
                    achievement.goalsReferences.category = doc(db, "categoriesAchievementsList", achievement.goalsReferences.category.id);
                }
                if(achievement.goalsReferences && achievement.goalsReferences.interval !== ""){
                    achievement.goalsReferences.interval = doc(db, "intervalsAchievementsList", achievement.goalsReferences.interval.id);
                }
                console.log(achievement);
                if(achievement.goalsReferences && achievement.goalsReferences.specificWorkout && achievement.goalsReferences.specificWorkout.isReferenced){
                    achievement.goalsReferences.specificWorkout.ref = doc(db, achievement.goalsReferences.specificWorkout.collection, achievement.goalsReferences.specificWorkout.ref.id);
                }

                await updateDoc(doc(db, "achievementsList", achievement.id), achievement);
                resolve(achievement.id);
            });
        },

        //Types Achievemenets
        GetTypesAchievementsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "typesAchievementsList"))
                    const typesAchievementsList = []
                    querySnapshot.forEach((docSnap) =>  {
                        typesAchievementsList.push({ ...docSnap.data(), id: docSnap.id })
                    })
                    commit('SET_TYPES_ACHIEVEMENTS_LIST', typesAchievementsList)
                    resolve(typesAchievementsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateTypeAchievement({}, typeAchievement) {
            return new Promise(async(resolve, reject) => {
                try {
                    const newDocRef = doc(collection(db, "typesAchievementsList"));
                    typeAchievement.id = newDocRef.id;
                    await setDoc(newDocRef, typeAchievement);
                    resolve(newDocRef.id);
                } catch (error) {
                    reject(err);
                }
            })
        },
        UpdateTypeAchievement({}, type) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "typesAchievementsList", type.id), type)
                    resolve(type.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteTypeAchievement({}, type) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, "typesAchievementsList", type.id))
                    resolve(type.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        //Categories Achievemenets
        GetCategoriesAchievementsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "categoriesAchievementsList"))
                    const categoriesAchievementsList = []
                    querySnapshot.forEach((doc) =>  {
                        categoriesAchievementsList.push(doc.data())
                    })
                    commit('SET_CATEGORIES_ACHIEVEMENTS_LIST', categoriesAchievementsList)
                    resolve(categoriesAchievementsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateCategoryAchievement({}, categoryAchievement) {
            return new Promise(async(resolve, reject) => {
                try {
                    const newDocRef = doc(collection(db, "categoriesAchievementsList"));
                    categoryAchievement.id = newDocRef.id;
                    await setDoc(newDocRef, categoryAchievement);
                    resolve(newDocRef.id);
                } catch (error) {
                    reject(err);
                }
            })
        },
        UpdateCategoryAchievement({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "categoriesAchievementsList", category.id), category)
                    resolve(category.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteCategoryAchievement({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, "categoriesAchievementsList", category.id))
                    resolve(category.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        //Intervals Achievemenets
        GetIntervalsAchievementsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "intervalsAchievementsList"))
                    const intervalsAchievementsList = []
                    querySnapshot.forEach((doc) =>  {
                        intervalsAchievementsList.push(doc.data())
                    })
                    commit('SET_INTERVALS_ACHIEVEMENTS_LIST', intervalsAchievementsList)
                    resolve(intervalsAchievementsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateIntervalAchievement({}, intervalAchievement) {
            return new Promise(async(resolve, reject) => {
                try {
                    const newDocRef = doc(collection(db, "intervalsAchievementsList"));
                    intervalAchievement.id = newDocRef.id;
                    await setDoc(newDocRef, intervalAchievement);
                    resolve(newDocRef.id);
                } catch (error) {
                    reject(err);
                }
            })
        },
        UpdateIntervalAchievement({}, interval) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "intervalsAchievementsList", interval.id), interval)
                    resolve(interval.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteIntervalAchievement({}, interval) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, "intervalsAchievementsList", interval.id))
                    resolve(interval.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        GetUserAchievements({ commit }, uid){
            return new Promise(async (resolve, reject) => {
                try {
                    const q = query(collection(db, "users", uid, "achievementsUnlocked"), orderBy('createdAt', 'desc'))
                    const querySnapshot = await getDocs(q)
                    const userAchievements = []
                    if(!querySnapshot.empty){
                        console.log(querySnapshot);
                        let achievementsGetted = querySnapshot.docs
                        for (let i = 0; i < achievementsGetted.length; i++) {
                            let achievement = achievementsGetted[i].data();
                            achievement.ref = await getDoc(achievement.ref).then(doc => doc.data())
                            userAchievements.push(achievement)
                        }
                    }
                    resolve(userAchievements)
                } catch(error) {
                    reject(error)
                }
            })
        }
    },
    getters:{
        getAchievementsList(state){
            return state.achievementsList;
        },
        getLoadingStatusAchievementIcon(state){
            return state.loadingStatusAchievementIcon
        },
        getTypesAchievementsList(state){
            return state.typesAchievementsList;
        },
        getCategoriesAchievementsList(state){
            return state.categoriesAchievementsList;
        },
        getIntervalsAchievementsList(state){
            return state.intervalsAchievementsList;
        },
    },
}